import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: '',
    coreDirectoryEndpoint: 'https://e0x6p0ejua.execute-api.eu-west-2.amazonaws.com/dev',
    portalEndpoint: 'https://2bwm5ahsok.execute-api.eu-west-2.amazonaws.com/Dev',
    accessToken: ''
  },
  mutations: {
    setUser (state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    accessToken (state, token) {
      state.accessToken = token
      localStorage.setItem('accessToken', token)
      window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    },
    logout (state) {
      state.accessToken = ''
      localStorage.clear()
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    coreDirectoryEndpoint (state) {
      return state.coreDirectoryEndpoint
    },
    portalEndpoint (state) {
      return state.portalEndpoint
    },
    accessToken (state) {
      return state.accessToken
    }
  },
  actions: {

  }
})
